import {Directive} from '@angular/core';

@Directive({
    selector: '[appContentPrefix]',
    standalone: true
})
export class ContentPrefixDirective {
}
